import Framebus from 'framebus'

const framebus = new Framebus()

framebus.target({
  origin: '*'
})

export default framebus
